import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import ChangiForm from './components/ChangiForm';
import FileUploadForm from './components/FileUploadForm'; 
import QueryExportForm from './components/QueryExportForm'; 
import MainMenu from './components/MainMenu'; 
import Login from './components/Login'; 
import './App.css';
import Logout from './components/Logout';
import ChangePassword from './components/ChangePassword';
import FindRecord from './components/FindRecord';
import CAGForm from './components/CAGForm';
import PartnerForm from './components/PartnerForm';
import Offboard from './components/Offboard';
import OffboardBulk from './components/OffboardBulk';
import GetStats from './components/GetStats';
import ProtectedRoute from './components/ProtectedRoute';

function App() {
  console.log('App component is rendering...');
  
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/" element={<ChangiForm />} />
          <Route path="/login" element={<Login />} />
          <Route path="/logout" element={<Logout />} />
          <Route path="/cag" element={<CAGForm />} />
          <Route path="/partners" element={<PartnerForm />} />

          <Route path="/csv" element={
            <ProtectedRoute>
              <FileUploadForm />
            </ProtectedRoute>
          } />

          <Route path="/query" element={
            <ProtectedRoute>
              <QueryExportForm />
            </ProtectedRoute>
          } />

          <Route path="/mainmenu" element={
            <ProtectedRoute>
              <MainMenu />
            </ProtectedRoute>
          } />

          <Route path="/changepassword" element={
            <ProtectedRoute>
              <ChangePassword />
            </ProtectedRoute>
          } />

          <Route path="/find" element={
            <ProtectedRoute>
              <FindRecord />
            </ProtectedRoute>
          } />

          <Route path="/offboard" element={
            <ProtectedRoute>
              <Offboard />
            </ProtectedRoute>
          } />

          <Route path="/getstats" element={
            <ProtectedRoute>
              <GetStats />
            </ProtectedRoute>
          } />

          <Route path="/offboardbulk" element={
            <ProtectedRoute>
              <OffboardBulk />
            </ProtectedRoute>
          } />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
